export default __webpack_public_path__ + "static/media/pic.17f89b55.jpg";